import Box from '@mui/material/Box';
import { useStacklineTheme } from '@stackline/ui';
import { getAppSubscriptionTier, updateUrlQueryParams, getCurrentContentVersion } from 'src/utils/app';
import React, { useMemo } from 'react';
import KeyMetricCards, {
  KeyMetricCardDefinition
} from 'src/components/BeaconV2Components/KeyMetricCards/KeyMetricCards';
import { KEY_METRICS_CONTAINER_ADJUSTED_WIDTH } from 'src/components/Layout/Beacon/BeaconProLayoutConsts';
import { useHistory } from 'src/utils/Hooks';
import {
  beaconBasicCards,
  beaconProCards
} from 'src/components/BeaconV2Components/ExperimentalLayout/Summary/beaconBasicConst';

const titleOverrides = {
  advertising: {
    clicks: 'Ad Clicks',
    costPerClick: 'CPC'
  },

  sales: {
    purchaseRate: 'Conversion',
    stacklineSku: 'Products'
  },
  reviews: {
    stars: 'Rating'
  },
  buybox: {
    winPercentage: 'Buy Box'
  },
  traffic: {
    stacklineSku: 'Products'
  },
  'new-content-metrics': {
    contentScore: 'Content'
  },
  'ratings-reviews-metrics-v2': {
    weeklyReviewVolume: 'Reviews'
  }
};

/**
 * Shows all the key metric summary cards for the home page
 */
const SummaryKeyMetricCards = () => {
  const theme = useStacklineTheme();
  const history = useHistory();
  const appSubscriptionTier = getAppSubscriptionTier();
  const currentContentVersion = getCurrentContentVersion();
  let cardMap = appSubscriptionTier === 'basic' ? beaconBasicCards : beaconProCards;

  if (appSubscriptionTier !== 'basic') {
    cardMap = cardMap.map((columnDefinitions) => {
      return columnDefinitions.map(([indexName, fieldName, tab, subtab]) => {
        if (subtab === 'reviewTrends') {
          return [indexName, fieldName, tab, 'reviews'];
        }
        if (tab === 'contentV2' && subtab === 'contentSummary') {
          const contentTab = currentContentVersion;
          let contentSubtab = subtab;

          if (contentTab === 'contentV3') {
            contentSubtab = 'contentUtilization';
          }

          if (contentTab === 'content') {
            contentSubtab = 'contentScore';
          }

          return [indexName, fieldName, contentTab, contentSubtab];
        }

        return [indexName, fieldName, tab, subtab];
      });
    });
  }

  const cardDefinitions: KeyMetricCardDefinition[][] = useMemo(
    () =>
      cardMap.map((columnDefinitions) =>
        columnDefinitions.map(([indexName, fieldName, tab, subtab]) => ({
          indexName,
          fieldName,
          title: titleOverrides[indexName] ? titleOverrides[indexName][fieldName] : undefined,
          onClick: () => history.push(updateUrlQueryParams({ tab, subtab })),
          primaryAggregationBuilder:
            indexName === 'sales' && fieldName === 'stacklineSku'
              ? (aggregationBuilder) => {
                  return aggregationBuilder.clearConditionRangeFilters().addConditionRangeFilter('retailSales', 1);
                }
              : undefined,
          secondaryAggregationBuilder:
            indexName === 'sales' && fieldName === 'stacklineSku'
              ? (aggregationBuilder) => {
                  return aggregationBuilder.clearConditionRangeFilters().addConditionRangeFilter('retailSales', 1);
                }
              : undefined
        }))
      ),
    [cardMap, history]
  );

  return (
    <Box
      marginTop={theme.spacing.lg}
      marginBottom={theme.spacing.lg}
      sx={{
        transform: 'translateX(-16px)',
        width: KEY_METRICS_CONTAINER_ADJUSTED_WIDTH
      }}
    >
      <KeyMetricCards cardDefinitionsByColumn={cardDefinitions} />
    </Box>
  );
};

export default SummaryKeyMetricCards;
